import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

const ProjectMapAllowed = () => {
	const hasFeature = useFeatureAvailable(Feature.PROJECT_PLAN);
	return hasFeature;
};

export default ProjectMapAllowed;
